import {tap} from 'rxjs/operators';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

import {LoginService} from 'app/core/login/login.service';
import {TRACKING_API_URL} from 'app/app.constants';

export class AuthExpiredInterceptor implements HttpInterceptor {
    constructor(private _loginService: LoginService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse && err.status === 401) {
                        // A 401 means our HaulierMagic session expired only when it comes from the HM API.
                        // The same JWT is forwarded to other services (e.g. the tracking API); a 401 from
                        // those is a service-specific rejection and must NOT log the user out of HM.
                        // Add any other forwarded-token host to this exclusion.
                        const url = request && request.url ? request.url : '';
                        const isTrackingApiCall = !!TRACKING_API_URL && url.startsWith(TRACKING_API_URL);
                        if (!isTrackingApiCall) {
                            console.log('[AuthExpiredInterceptor] Authentication has expired. Logging out.');
                            this._loginService.logout(false, false);
                        }
                    }
                }
            )
        );
    }
}
